export function successNotifyService(payload) {
  const currentThis = payload.currentThis;
  const title = payload.title;
  const text = payload.text;

  currentThis.$vs.notify({
    title,
    text,
    iconPack: "feather",
    icon: "icon-check-circle",
    color: "success",
    fixed: false,
  });
}

export function failureNotifyService(payload) {
  const currentThis = payload.currentThis;
  const title = payload.title;
  const text = payload.text;

  currentThis.$vs.notify({
    title,
    text,
    iconPack: "feather",
    icon: "icon-alert-circle",
    color: "danger",
    fixed: false,
  });
}
